import './App.css'
import { Navigate, Route, Routes, Outlet, useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { useAppDispatch } from './redux/store'
import { clearFilters as clearEventReportFilters } from './redux/reports/event/invitedTeamMemberPerEvent/slice'
import { clearFilters as clearTeamMemberFilters } from './redux/teamMember/slice'
import { clearFilters as clearTaskReportFilters } from './redux/reports/task/assignedTeamMemberPerTask/slice'

import GoogleLogin from './auth/GoogleLogin'
import Redirect from './auth/Redirect'
import OverviewPage from './pages/OverviewPage'
import ManageEventPage from './pages/ManageEventPage'
import ViewEventPage from './pages/ViewEventPage'
import SweetAlertPanel from './Components/Common/SweetAlert/SweetAlertPanel'
import ColorPanel from './Components/Common/Color/ColorPanel'
import TypographyPanel from './Components/Common/Typography/TypographyPanel'
import ButtonPanel from './Components/Common/Button/ButtonPanel'
import BadgePanel from './Components/Common/Badge/BadgePanel'
import ModalPanel from './Components/Common/Modal/ModalPanel'
import SwitchPanel from './Components/Common/Switch/SwitchPanel'
import ProtectedRoute from './Components/Common/Route/ProtectedRoute'
import CombinedProviders from './CombinedProvide'
import TaskPage from './pages/TaskPage'
import UnauthorizedPage from './pages/error/UnauthorizedPage'
import ComingSoonPage from './pages/error/CommingSoonPage'
import NoAccessPage from './pages/error/NoAccessPage'
import EventReportPage from './pages/Report/EventReportPage'
import TaskReportPage from './pages/Report/TaskReportPage'
import ViewEventReport from './Components/Report/EventReport/ViewEvent/index'
// import { useEffect } from 'react'
import Settings from './pages/Settings'
// import TeamRoster from './pages/TeamRoster'
import Dashboard from './Components/Common/Dashboard'
import NotFoundPage from './pages/error/NotFoundPage'
import UserGuidePage from './pages/UserGuidePage'
import FeedbackPage from './pages/FeedbackPage'

function App() {
  const dispatch = useAppDispatch()
  const location = useLocation()

  useEffect(() => {
    // Clear filters when route changes
    dispatch(clearEventReportFilters())
    dispatch(clearTeamMemberFilters())
    dispatch(clearTaskReportFilters())
  }, [location.pathname, dispatch])

  // Define routes dynamically
  const routes = [
    {
      path: '/overview',
      component: <OverviewPage />,
    },
    {
      path: '/events',
      component: <ViewEventPage />,
    },
    {
      path: '/events/:registrationCode',
      component: <ViewEventPage />,
    },
    {
      path: '/orders',
      component: <ComingSoonPage />,
    },
    {
      path: 'tasks',
      component: <TaskPage />,
    },
    {
      path: 'color',
      component: <ColorPanel />,
    },
    {
      title: 'TYPOGRAPHY',
      component: <TypographyPanel />,
    },
    {
      path: 'buttons',
      component: <ButtonPanel />,
    },
    {
      path: 'badge',
      component: <BadgePanel />,
    },
    {
      path: 'modal',
      component: <ModalPanel />,
    },
    {
      path: 'switch',
      component: <SwitchPanel />,
    },
    {
      path: 'sweetAlert',
      component: <SweetAlertPanel />,
    },
    {
      path: '/unauthorized',
      component: <UnauthorizedPage />,
    },
    {
      path: '/settings',
      component: <Settings />,
    },
    {
      path: '/user-guide',
      component: <UserGuidePage />,
    },
    {
      path: '/support',
      component: <FeedbackPage />,
    },
  ]

  const adminRoutes = [
    {
      path: '/events/manage-events',
      component: <ManageEventPage />,
    },
    {
      path: '/order/manage-orders',
      component: <ComingSoonPage />,
    },
    {
      path: 'team-roster',
      component: <ComingSoonPage />,
    },
    {
      path: 'expenses',
      component: <ComingSoonPage />,
    },
    {
      path: 'reports/event',
      component: <EventReportPage />,
    },
    {
      path: 'reports/task',
      component: <TaskReportPage />,
    },
    {
      path: 'reports/event/:id',
      component: <ViewEventReport />,
    },
  ]

  // const navigate = useNavigate()

  // useEffect(() => {
  //   const SESSION_TIMEOUT = 30 * 60 * 1000 // 30 minutes
  //   const handleSessionTimeout = () => {
  //     sessionStorage.clear()
  //     localStorage.clear()
  //     navigate('/login', { replace: true })
  //   }

  //   const resetTimeout = () => {
  //     clearTimeout(sessionTimer)
  //     sessionTimer = setTimeout(handleSessionTimeout, SESSION_TIMEOUT)
  //   }

  //   window.addEventListener('mousemove', resetTimeout)
  //   window.addEventListener('keydown', resetTimeout)

  //   let sessionTimer = setTimeout(handleSessionTimeout, SESSION_TIMEOUT)

  //   return () => {
  //     window.removeEventListener('mousemove', resetTimeout)
  //     window.removeEventListener('keydown', resetTimeout)
  //     clearTimeout(sessionTimer)
  //   }
  // }, [])

  return (
    <CombinedProviders>
      <Routes>
        <Route path='/login' element={<GoogleLogin />} />
        <Route path='/redirect' element={<Redirect />} />
        <Route path='/no-access' element={<NoAccessPage />} />
        <Route path='/unauthorized' element={<UnauthorizedPage />} />
        <Route path='*' element={<NotFoundPage />} />

        <Route element={<ProtectedRoute allowedRoles={['teamMember', 'admin']} />}>
          <Route
            element={
              <Dashboard>
                <Outlet />
              </Dashboard>
            }
          >
            <Route path='/' element={<Navigate to='/overview' replace />} />
            {routes.map(({ path, component }) => (
              <Route key={path} path={path} element={component} />
            ))}
          </Route>
        </Route>

        <Route element={<ProtectedRoute allowedRoles={['admin']} />}>
          <Route
            element={
              <Dashboard>
                <Outlet />
              </Dashboard>
            }
          >
            <Route path='/' element={<Navigate to='/overview' replace />} />
            {adminRoutes.map(({ path, component }) => (
              <Route key={path} path={path} element={component} />
            ))}
          </Route>
        </Route>
      </Routes>
    </CombinedProviders>
  )
}

export default App
